module.exports = __webpack_public_path__ + "img/up.4bafda9a.svg";